import api, {
  BOARDS,
  CITIES_URL,
  CONTRIES_URL,
  COURSES_URL,
  PROVINCES_URL,
  SLOT_URL,
  TEACHERS_URL,
  TEACHER_MEDIA_URL,
} from "./api";

export const getCountriesAPI = async () => {
  return await api.get(`${CONTRIES_URL}`);
};

export const getProvenciesAPI = async (id) => {
  return await api.get(`${CONTRIES_URL}/${id}/provinces`);
};

export const getCitiesAPI = async (id) => {
  return await api.get(`${PROVINCES_URL}/${id}/cities`);
};

export const getAreasAPI = async (id) => {
  return await api.get(`${CITIES_URL}/${id}/areas`);
};

export const teacherSubmit = async (teacherId, data) => {
  return await api.put(`${TEACHERS_URL}/${teacherId}`, data);
};
export const teacherGet = async (id) => {
  return await api.get(`${TEACHERS_URL}/${id}`);
};

export const saveTeacherEducation = async (teacherId, data) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}/educations`, data);
};
export const deleteTeacherEducation = async (teacherId, educationId) => {
  return await api.delete(
    `${TEACHERS_URL}/${teacherId}/educations/${educationId}`
  );
};

export const fetchTeacherEducations = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/educations`);
};
export const updateTeacherEducation = async (teacherId, educationId, body) => {
  return await api.put(
    `${TEACHERS_URL}/${teacherId}/educations/${educationId}`,
    body
  );
};

export const createTeacherAcademicExperiance = async (teacherId, data) => {
  return await api.post(
    `${TEACHERS_URL}/${teacherId}/academicExperiences`,
    data
  );
};

export const fetchTeacherAcademicExperiance = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/academicExperiences`);
};
export const updateTeacherAcademicExperiance = async (teacherId, data) => {
  return await api.put(
    `${TEACHERS_URL}/${teacherId}/academicExperiences`,
    data
  );
};
export const deleteTeacherAcademicExperiance = async (
  teacherId,
  experianceId
) => {
  return await api.delete(
    `${TEACHERS_URL}/${teacherId}/academicExperiences/${experianceId}`
  );
};

export const createTeacherCorporateExperiance = async (teacherId, data) => {
  return await api.post(
    `${TEACHERS_URL}/${teacherId}/corporateExperiences`,
    data
  );
};

export const fetchTeacherCorporateExperiance = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/corporateExperiences`);
};
export const updateTeacherCorporateExperiance = async (teacherId, data) => {
  return await api.put(
    `${TEACHERS_URL}/${teacherId}/corporateExperiences`,
    data
  );
};

export const deleteTeacherCorporateExperiance = async (
  teacherId,
  experianceId
) => {
  return await api.delete(
    `${TEACHERS_URL}/${teacherId}/corporateExperiences/${experianceId}`
  );
};

export const postTeacherAreas = async (teacherId, data) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}/areas`, data);
};

export const getTeacherAreas = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/areas`);
};

//
export const coursesHeaders = async () => {
  return await api.get(`${COURSES_URL}/headers`);
};

export const coursesSubjects = async (id) => {
  return await api.get(`${COURSES_URL}/subjects/${id}`);
};

// /api/v1/courses/subjects/:id

/**
 *
 * @param {*} courseHeaderId
 * @returns
 */
export const fetchSubjects = async (courseHeaderId) => {
  return await api.get(`${COURSES_URL}/subjects/${courseHeaderId}`);
};
/**
 *
 * @param {*} courseHeaderId
 * @returns
 */
export const fetchSubjectLevels = async (courseHeaderId) => {
  return await api.get(`${COURSES_URL}/levels/${courseHeaderId}`);
};

export const getAllTeachers = async (id) => {
  return await api.get(`${TEACHERS_URL}/getAllTeachers`);
};

export const fetchAllTeachers = async () => {
  return await api.get("/teachers");
};

export const createSlots = async (teacherId, slots) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}/slots`, slots);
};

export const updateSlot = async (slotId, body) => {
  return await api.put(`${SLOT_URL}/${slotId}`, body);
};

export const fetchWeekDays = async () => {
  return await api.get(`/days`);
};

export const fetchTeacherSlots = async (teacherId, body) => {
  return await api.post(
    `${TEACHERS_URL}/${teacherId}/slots/status/monthly`,
    body
  );
};

export const fetchTeacherWeeklySlots = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/slots`);
};

export const fetchTeacherscheduledMeetings = async (
  teacherId,
  startDate,
  endDate
) => {
  return await api.get(
    `${TEACHERS_URL}/${teacherId}/meetings/from/${startDate}/to/${endDate}`
  );
};

export const fetchTeacherOffers = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/offers`);
};

export const uploadTeacherMedia = async (teacherId, body) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}/media`, body);
};

export const fetchOfferSlots = async (teacherId, offerId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/offers/${offerId}`);
};

export const fetchTeacherDocuments = async (teacherId, body) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}/getMedia`, body);
};

export const deleteTeacherDocuments = async (teacherMediaId) => {
  return await api.delete(`${TEACHER_MEDIA_URL}/${teacherMediaId}`);
};

export const saveTeacherTeachingArea = async (teacherId, body) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}/areas`, body);
};

export const fetchTeacherTeachingAreas = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/areas`);
};
export const deleteTeacherTeachingArea = async (teacherId, areaId) => {
  return await api.delete(`${TEACHERS_URL}/${teacherId}/areas/${areaId}`);
};
export const updateTeacherTeachingArea = async (teacherId, areaId, body) => {
  return await api.put(`${TEACHERS_URL}/${teacherId}/areas/${areaId}`, body);
};

export const fetchTeacherTeachingBoards = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}${BOARDS}`);
};
export const saveTeacherTeachingBoards = async (teacherId, body) => {
  return await api.post(`${TEACHERS_URL}/${teacherId}${BOARDS}`, body);
};
export const updateTeacherTeachingBoards = async (teacherId, boardId, body) => {
  return await api.put(
    `${TEACHERS_URL}/${teacherId}${BOARDS}/${boardId}`,
    body
  );
};

export const fetchTeacherAllData = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/getTeacherAllData`);
};

export const fetchTeacherNotifications = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/warnings`);
};

export const getTeacherReviews = async (teacherId) => {
  return await api.get(`${TEACHERS_URL}/${teacherId}/reviews`);
};
